import React from 'react'
import styled from 'styled-components'

const StyledPaginationNav = styled.nav`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`

function PaginationNav({ currentPage, totalPages, basePath }) {
  if (totalPages <= 1) return null

  return (
    <StyledPaginationNav aria-label="Paginazione archivio">
      {Array.from({ length: totalPages }, (_, index) => {
        const pageNumber = index + 1
        const href = pageNumber === 1 ? basePath : `${basePath}?page=${pageNumber}`

        return (
          <a
            key={pageNumber}
            href={href}
            aria-current={pageNumber === currentPage ? 'page' : undefined}
            aria-label={`Pagina ${pageNumber}`}
          >
            {pageNumber}
          </a>
        )
      })}
    </StyledPaginationNav>
  )
}

export default PaginationNav
